module.exports = __webpack_public_path__ + "img/stock2.0281144a.png";